const API_URL = process.env.REACT_APP_API.trim();

export default API_URL;



// WEBPACK FOOTER //
// ./src/utils/api-url.js